/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_Qty_PlaceholderInputs */

const vi_lot_items_split_qty_placeholder = /** @type {(inputs: Lot_Items_Split_Qty_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL (kg)`)
};

/**

* @param {Lot_Items_Split_Qty_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_qty_placeholder = /** @type {((inputs?: Lot_Items_Split_Qty_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_Qty_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_qty_placeholder(inputs)
});